module.exports = __webpack_public_path__ + "img/thumb_25.e6e9daeb.jpg";